    <td [ngClass]='highlightService.class(projectNote.created, projectNote.updated)'
        style='vertical-align: top;white-space:nowrap;'>
        {{projectNote.noteDate | date:'MMM yyyy'}}
    </td>
    <td></td>
    <td [innerHTML]='projectNote.note | highlight: searchTerm'
        ng-class='highlightClass(projectNote.created, projectNote.updated);'>
    </td>
    <td style='vertical-align: top;white-space:nowrap;'>
        <ul class='list-unstyled ' *ngFor='let noteType of projectNote.noteTypes'>
            <li [ngClass]='highlightService.class(noteType.created, noteType.created)'>
                {{noteType.noteType}}
            </li>
        </ul>
    </td>
    <td>
    </td>

